import lodashCompact from 'lodash/fp/compact';
import lodashFlatten from 'lodash/fp/flatten';

export const SR_APPLICATION_ASSEMBLY_LINE_STATUS_NOT_STARTED = 'NotStarted';
export const SR_APPLICATION_ASSEMBLY_LINE_STATUS_IN_PROGRESS = 'InProgress';
export const SR_APPLICATION_ASSEMBLY_LINE_STATUS_NOT_QUALIFIED = 'NotQualified';
export const SR_APPLICATION_ASSEMBLY_LINE_STATUS_QUALIFIED = 'Qualified';
export const SR_APPLICATION_ASSEMBLY_LINE_INCOME_MAX_DAYS_DIFF = 180;
export const SR_APPLICATION_ASSEMBLY_LINE_NEXT_HOUSEHOLD_MONTHS_AHEAD = 3;

export const SR_APPLICATION_ASSEMBLY_LINE_STATUS_TO_COLOR_MAPPING = {
  [SR_APPLICATION_ASSEMBLY_LINE_STATUS_NOT_STARTED]: '#132630',
  [SR_APPLICATION_ASSEMBLY_LINE_STATUS_IN_PROGRESS]: '#E7711B',
  [SR_APPLICATION_ASSEMBLY_LINE_STATUS_QUALIFIED]: '#00A238',
  [SR_APPLICATION_ASSEMBLY_LINE_STATUS_NOT_QUALIFIED]: '#E8001D',
};

export const SR_APPLICATION_ASSEMBLY_LINE_STATUSES = [
  SR_APPLICATION_ASSEMBLY_LINE_STATUS_NOT_STARTED,
  SR_APPLICATION_ASSEMBLY_LINE_STATUS_QUALIFIED,
  SR_APPLICATION_ASSEMBLY_LINE_STATUS_IN_PROGRESS,
  SR_APPLICATION_ASSEMBLY_LINE_STATUS_NOT_QUALIFIED,
];

/**
 * Gets the latest status out of an assembly line status array.
 *
 * The returned status depends on the following conditions,
 * ordered by highest priority on the top:
 *
 * - Qualified: All statuses are Qualified.
 * - Not qualified: At least one status is NotQualified.
 * - In progress: At least one status is InProgress
 * - Not started: All the statuses are NotStarted
 *
 * @param  {Array}  statuses  Status list.
 * @return {string}           The latest status.
 */
export const getLatestStatus = (statuses) => {
  if (!statuses) {
    return null;
  }
  statuses = lodashCompact(lodashFlatten(statuses));

  if (
    statuses.length > 0
    && statuses.every((status) => status === SR_APPLICATION_ASSEMBLY_LINE_STATUS_QUALIFIED)
  ) {
    return SR_APPLICATION_ASSEMBLY_LINE_STATUS_QUALIFIED;
  }

  if (statuses.length === 0
    || statuses.every((status) => status === SR_APPLICATION_ASSEMBLY_LINE_STATUS_NOT_STARTED)
  ) {
    return SR_APPLICATION_ASSEMBLY_LINE_STATUS_NOT_STARTED;
  }

  if (
    statuses.length > 0
    && statuses.some((status) => status === SR_APPLICATION_ASSEMBLY_LINE_STATUS_NOT_QUALIFIED)
  ) {
    return SR_APPLICATION_ASSEMBLY_LINE_STATUS_NOT_QUALIFIED;
  }

  return SR_APPLICATION_ASSEMBLY_LINE_STATUS_IN_PROGRESS;
};

export const getNextStatus = (statuses) => {
  if (!statuses) {
    return null;
  }
  statuses = lodashCompact(lodashFlatten(statuses));

  if (statuses.includes(SR_APPLICATION_ASSEMBLY_LINE_STATUS_IN_PROGRESS)) {
    return SR_APPLICATION_ASSEMBLY_LINE_STATUS_IN_PROGRESS;
  }

  if (statuses.includes(SR_APPLICATION_ASSEMBLY_LINE_STATUS_NOT_STARTED)) {
    return SR_APPLICATION_ASSEMBLY_LINE_STATUS_NOT_STARTED;
  }

  return null;
};

export const getNextStatusIndex = (statuses) => {
  if (!statuses) {
    return null;
  }
  const nextStatus = getNextStatus(statuses);
  return statuses.findIndex((status) => status === nextStatus);
};
